import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isWide, setIsWide] = useState(false);
  const [bgPos, setBgPos] = useState('center 40%');
  const [bgSize, setBgSize] = useState('cover');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const update = () => {
      const ratio = window.innerWidth / window.innerHeight;
      if (ratio > 1.7) {
        setIsWide(true);
        setBgSize('auto 100%');
        setBgPos('center');
      } else {
        setIsWide(false);
        setBgSize('cover');
        if (ratio > 1.4) setBgPos('center 41%');
        else if (ratio > 1.0) setBgPos('center 38%');
        else setBgPos('center 35%');
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <div>
      <section
        className="relative w-full overflow-hidden"
        style={{ minHeight: '100vh', backgroundColor: isWide ? '#F7EADB' : undefined }}
      >
        <div
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundImage: `url('/assets/gallery/496948084_17861483769406413_289227369687086936_n.jpg')`,
            backgroundSize: bgSize,
            backgroundPosition: bgPos,
            backgroundRepeat: 'no-repeat',
            transform: `scale(${1 + scrollY * 0.0003}) translateY(${scrollY * 0.3}px)`,
            willChange: 'transform',
          }}
        />
        {/* Overlay: on wide screens only cover the square image, not the beige sides */}
        {isWide ? (
          <div
            className="absolute bg-black/30"
            style={{ top: 0, bottom: 0, aspectRatio: '1/1', left: '50%', transform: 'translateX(-50%)' }}
          />
        ) : (
          <div className="absolute inset-0 bg-black/30" />
        )}
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 py-24 landscape:py-16" style={{ minHeight: '100vh' }}>
          <h1 className="font-script font-bold text-friet-beige text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-6 drop-shadow-2xl" style={{ textShadow: '0 4px 20px rgba(0,0,0,0.4)' }}>
            - Net dat beetje extra -
          </h1>
          <p className="font-serif text-friet-beige/90 text-base sm:text-lg md:text-xl max-w-2xl leading-relaxed mb-10 drop-shadow-lg" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
            Passie! Dit is waar Frietplus foodtruck voor staat.<br />
            Een passie voor lekker, vers eten met net dat beetje extra.
          </p>
          <Link
            to="/over-ons"
            className="inline-block px-10 py-4 border-2 border-friet-beige text-friet-beige font-serif text-lg tracking-wider uppercase hover:bg-friet-beige hover:text-friet-black transition-all duration-300"
          >
            Our story
          </Link>
          <div className="mt-10 animate-bounce">
            <i className="fas fa-chevron-down text-friet-beige/60 text-2xl"></i>
          </div>
        </div>
      </section>

      <div className="bg-friet-beige py-14">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto text-center mb-10">
            <h2 className="font-serif text-3xl md:text-4xl text-friet-black tracking-wide">
              Onze Formules
            </h2>
            <div className="w-16 h-[2px] bg-friet-red mx-auto mt-4"></div>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-4 max-w-5xl mx-auto">
            <Link to="/weddings#section-options" className="group flex flex-col items-center px-3 py-4 rounded-2xl hover:bg-friet-beige transition-all">
              <div className="w-14 h-14 bg-friet-red/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-friet-red/20 transition-colors">
                <i className="fas fa-wine-glass-alt text-friet-red text-lg"></i>
              </div>
              <span className="font-script font-bold text-friet-red text-xl md:text-2xl">Apperitief</span>
            </Link>
            <span className="hidden md:block text-friet-gold text-2xl font-light">|</span>
            <Link to="/weddings#section-plus" className="group flex flex-col items-center px-3 py-4 rounded-2xl hover:bg-friet-beige transition-all">
              <div className="w-14 h-14 bg-friet-red/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-friet-red/20 transition-colors">
                <i className="fas fa-plus text-friet-red text-lg"></i>
              </div>
              <span className="font-script font-bold text-friet-red text-xl md:text-2xl">Plus+</span>
            </Link>
            <span className="hidden md:block text-friet-gold text-2xl font-light">|</span>
            <Link to="/weddings#section-party" className="group flex flex-col items-center px-3 py-4 rounded-2xl hover:bg-friet-beige transition-all">
              <div className="w-14 h-14 bg-friet-red/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-friet-red/20 transition-colors">
                <i className="fas fa-music text-friet-red text-lg"></i>
              </div>
              <span className="font-script font-bold text-friet-red text-xl md:text-2xl">Party</span>
            </Link>
            <span className="hidden md:block text-friet-gold text-2xl font-light">|</span>
            <Link to="/weddings#section-options" className="group flex flex-col items-center px-3 py-4 rounded-2xl hover:bg-friet-beige transition-all">
              <div className="w-14 h-14 bg-friet-red/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-friet-red/20 transition-colors">
                <i className="fas fa-sliders-h text-friet-red text-lg"></i>
              </div>
              <span className="font-script font-bold text-friet-red text-xl md:text-2xl">Options</span>
            </Link>
            <span className="hidden md:block text-friet-gold text-2xl font-light">|</span>
            <Link to="/weddings#section-dessert" className="group flex flex-col items-center px-3 py-4 rounded-2xl hover:bg-friet-beige transition-all">
              <div className="w-14 h-14 bg-friet-red/10 rounded-full flex items-center justify-center mb-3 group-hover:bg-friet-red/20 transition-colors">
                <i className="fas fa-ice-cream text-friet-red text-lg"></i>
              </div>
              <span className="font-script font-bold text-friet-red text-xl md:text-2xl">Homemade Dessert</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
